import { Observable } from 'rxjs';
import { FetchMenuResponse } from '../types/fetch-menu-response.type';

export abstract class IHubsterRepository {
  abstract fetchPublishedMenu(): Observable<FetchMenuResponse>;
  abstract fetchAdminMenu(): Observable<FetchMenuResponse>;
}
